<div *ngIf="showDownloadMessage" class="download-container">
    <p class="download-message">
        <strong>Note:</strong> This file cannot be previewed in your current browser. 
        <span *ngIf="isIE">(Internet Explorer has limited PDF viewing support)</span>
        Please download the file to view it with Adobe Reader or another PDF viewer.
    </p>
    <button (click)="downloadFile()" class="download-button">Download Document</button>
</div>

<iframe *ngIf="!showDownloadMessage" title="Document" [src]="fileUrl" width="100%" autosize style="height: calc(100vh - 50px);">
</iframe>